var path = '/pages/guestlists/views/rsvps-master-changelog.tpl.html';
var html = "<al-entity-change-log entity=\"'rsvp'\"></al-entity-change-log>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/guestlists/views/rsvps-master-changelog.tpl.html
// module id = 2288
// module chunks = 1